<ion-content>
	<div class="banner-container">
		<img class="header-banner-tmp" alt="" src="../../../assets/icons/tmp-banners/dancebug-something-went-wrong-banner.svg" />
	</div>
	<app-loading class="frame-stack-110000" [loading]="(loadingWithSpinner$ | async) ?? false"></app-loading>
	<div class="d-flex flex-col ion-align-items-center ion-justify-content-center ion-padding ion-text-center mt-55">
		<div class="my-55"></div>
		<ion-text class="ion-margin-bottom" color="primary">
			<strong> {{ lang$ | async | langTag : 'This app requires an internet connection.' }} </strong>
		</ion-text>
		<ion-text class="ion-margin-bottom" color="primary">
			{{ lang$ | async | langTag : 'Please connect to the internet on your device and refresh below.' }}
		</ion-text>
		<ion-button class="ion-margin w-100" shape="round" expand="block" (click)="refreshApp()">
			<strong> {{ lang$ | async | langTag : 'Refresh' : 'uppercase' }} </strong>
		</ion-button>
	</div>
</ion-content>
